import Vue from "vue";
import Router from "vue-router";
import Hello from "@/components/HelloWorld";
import MyNews from "@/components/school/news/MyNews";
import Asuulga from "@/components/school/asuulga/Asuulga";
import XADetail from "@/components/school/asuulga/XADetail";

import Home from "@/components/Home";
import Login from "@/components/login/Login";
import Adminman from "@/components/login/Adminman";
import LessonAdd from "@/components/LessonAdd";
import LessonEdit from "@/components/LessonEdit";
import LessonDetail from "@/components/teacher/LessonDetail";
import LessonTime from "@/components/teacher/LessonTime";
import LessonGroup from "@/components/teacher/LessonGroup";
import LessonGroupStudents from "@/components/teacher/LessonGroupStudents";
import ContentDetail from "@/components/teacher/ContentDetail";
import QuestionDetail from "@/components/teacher/QuestionDetail";
import LessonStudent from "@/components/teacher/LessonStudent";
import LessonDetailForStudent from "@/components/student/LessonDetailPublic";
import ExamResult from "@/components/student/ExamResult";

 
import ShareLessonToPublicforStudent from "@/components/student/ShareLessonToPublicforStudent";
import LessonGrid from "@/components/LessonGrid";
import LessonGridXDaalgavar from "@/components/LessonGridXDaalgavar";

import AllLessonStudentScores from "@/components/AllLessonStudentScores";
import FinalScores from "@/components/FinalScores";

import Dashboard from "@/components/Dashboard";
import XDashboard from "@/components/XDashboard";


import MyDashboard from "@/components/MyDashboard";
import MyCalendar from "@/components/MyCalendar";

import LessonQuestionAdd from "@/components/LessonQuestionAdd";
import SubSchools from "@/components/SubSchools";

import CreateSchool from "@/components/admin/CreateSchool";
import CreateNewSemester from "@/components/admin/CreateNewSemester";
import CreateSchoolTeacherAdd from "@/components/admin/CreateSchool-TeachersAdd";
import CreateSchoolTeacherAddBySector from "@/components/admin/CreateSchool-TeachersAddBySector";

import ExternalQa from "@/components/ExternalQa";
import ExternalQaAdmin from "@/components/ExternalQaAdmin";
import SchoolDetail from "@/components/SchoolDetail";
import DepartmentDetail from "@/components/DepartmentDetail";
import Students from "@/components/Students";
import StudentsAnalyse from "@/components/StudentsAnalyse";


import StudentAdd from "@/components/StudentAdd";
import ProgramStudentAdd from "@/components/ProgramStudentAdd";
import Teachers from "@/components/Teachers";
import TeacherAdd from "@/components/TeacherAdd";
import AdminManagerAddEdit from "@/components/admin/AdminManagerAddEdit";


import LessonQA from "@/components/LessonQA";
import Register from "@/components/login/Register";
import AddInfo from "@/components/login/AddInfo";
import AllLessons from "@/components/AllLessons";
import DetailQuestions from "@/components/teacher/Questions";
import DetailQuestionAdd from "@/components/teacher/QuestionAdd";
import SimpleQuestionAdd from "@/components/teacher/SimpleQuestionAdd";
import QuestionAddBulk from "@/components/teacher/QuestionAddBulk";
import ImageAdd from "@/components/ImageAdd";
import StudentDetail from "@/components/student/StudentDetail";
import LessonAttendance from "@/components/teacher/LessonAttendance";
import TeachersAdd from "@/components/admin/TeachersAdd";
import StudentsAdd from "@/components/admin/StudentsAdd";
import Payments from "@/components/admin/Payments";
import HomeLogin from "@/components/login/HomeLogin";
import TeacherLogin from "@/components/login/TeacherLogin";
import LessonDetailAdmin from "@/components/admin/LessonDetailAdmin";
import UserProfile from "@/components/login/UserProfile";
import TestResult from "@/components/student/TestResult";
import QuestionsScore from "@/components/teacher/QuestionsScore";
import TopicCreateExam from "@/components/teacher/TopicCreateExam";
import LessonPayment from "@/components/teacher/LessonPayment";
import Cities from "@/components/city/Cities";
import CityDetail from "@/components/city/CityDetail";
import DistrictDetail from "@/components/city/Schools";
import SchoolCategory from "@/components/schoolcategory/SchoolCategory";
import SchoolCategoryAdd from "@/components/schoolcategory/SchoolCategoryAdd";
import SchoolSector from "@/components/schoolsector/SchoolSector";
import SchoolSectorAdd from "@/components/schoolsector/SchoolSectorAdd";
import SectorDetail from "@/components/schoolsector/SectorDetail";
import Semester from "@/components/semester/Semester";
import SemesterAdd from "@/components/semester/SemesterAdd";
import firebase from "firebase";

import XAddLesson from "@/components/school/lesson/XAddLesson";
import XILessonDetail from "@/components/school/lesson/XILessonDetail";
//import ILessonDetail from "@/components/school/lesson/ILessonDetail";

import ILessonAdd from "@/components/school/lesson/ILessonAdd";
import ILessonAddGroup from "@/components/school/lesson/ILessonAddGroup";
import ILessonEdit from "@/components/school/lesson/ILessonEdit";
import IContentDetail from "@/components/school/test/IContentDetail";
import IVideoFrame from "@/components/school/lesson/IVideoFrame";
import IVideoWatcher from "@/components/school/lesson/IVideoWatcher";
import IQuestions from "@/components/school/test/CreatingQuestions";
import ISimpleQuestionAdd from "@/components/school/test/ISimpleQuestionAdd";
import IQuestionAdd from "@/components/school/test/IQuestionAdd";
import IQuestionsScore from "@/components/school/test/IQuestionsScore";
import IQuestionDetail from "@/components/school/test/IQuestionDetail";
import IQuestionAddBulk from "@/components/school/test/IQuestionAddBulk";
import ILessonGroup from "@/components/school/lesson/ILessonGroup";
import ILessonGroupExam from "@/components/school/lesson/ILessonGroupExam";

import ILessonShare from "@/components/school/lesson/ILessonShare";
import ILessonGroupStudents from "@/components/school/lesson/ILessonGroupStudents";
import ILessonTime from "@/components/school/lesson/ILessonTime";
import ILessonLog from "@/components/school/lesson/ILessonLog";
import ILessonSchedule from "@/components/school/lesson/ILessonSchedule";
import ILessonLogDetail from "@/components/school/lesson/ILessonLogDetail";
import ITeachersAdd from "@/components/school/ITeachersAdd";
import IStudentsAdd from "@/components/school/IStudentsAdd";
import AddAllStudents from "@/components/school/AddAllStudents";

import ILessonStats from "@/components/school/lesson/ILessonStats";
import ILessonContentScores from "@/components/school/lesson/ILessonContentScores";
import ILessonScores from "@/components/school/lesson/ILessonScores";
import ILessonScoresDaalgavar from "@/components/school/lesson/ILessonScoresDaalgavar";


import ILessonAssignment from "@/components/school/lesson/ILessonAssignment";
import SLessons from "@/components/school/admin/SLessons";
import SLessonsAll from "@/components/school/admin/SLessonsAll";
import SLessonsAll2 from "@/components/school/admin/SLessonsAll2";
import ListOfLessons from "@/components/school/admin/ListOfLessons";
import SProgramLessons from "@/components/school/admin/SProgramLessons";
import XProgramFinalexamScores from "@/components/school/admin/XProgramFinalexamScores";
import MyClassLessons from "@/components/school/admin/MyClassLessons";
import CheckClassLessons from "@/components/school/admin/CheckClassLessons";
import TobeRemovedLessons from "@/components/school/admin/TobeRemovedLessons";

import SLessonDetail from "@/components/school/admin/SLessonDetail";
import ShareLessonToPublic from "@/components/school/lesson/ShareLessonToPublic";


import SLessonGroup from "@/components/school/admin/SLessonGroup";
import SLessonGroupStudents from "@/components/school/admin/SLessonGroupStudents";
import SLessonTime from "@/components/school/admin/SLessonTime";
import STeachersLate from "@/components/school/admin/STeachersLate";
import SDepartments from "@/components/school/admin/SDepartments";
import Dungiinhavtgai from "@/components/school/admin/Dungiinhavtgai";
import SCategories from "@/components/school/admin/SCategories";
import DLessonsByCategory from "@/components/school/admin/DLessonsByCategory";
import DLessonsGrid from "@/components/school/admin/DLessonsGrid";
import AllLessonTimeTable from "@/components/school/admin/AllLessonTimeTable";


import NewsCategory from "@/components/school/news/NewsCategory";
import News from "@/components/school/news/News";
import XNews from "@/components/school/news/XNews";
import XNewsDetail from "@/components/school/news/XNewsDetail";


import TeacherLessons from "@/components/school/admin/TeacherLessons";
import IGroupStudents from "@/components/school/IGroupStudents";

import StudentContentDetail from "@/components/student/StudentContentDetail";
import StudentLog from "@/components/student/StudentLog";
import StudentScores from "@/components/student/StudentScores";
import StudentAssignment from "@/components/student/StudentAssignment";

import Groups from "@/components/school/group/Groups";
import GroupAdd from "@/components/school/group/GroupAdd";
import GroupStudent from "@/components/school/group/GroupStudent";
import { store } from "../store.js";
import ExamPage from "@/components/student/ExamPage";
import ExamReport from "@/components/student/ExamReport";
import XStudentPage from "@/components/student/XStudentPage.vue";

import TeacherAddFromPublic from "@/components/TeacherAddFromPublic";
import XOnlineRooms from "@/components/XOnlineRooms";
import XSongonOnlineRooms from "@/components/XSongonOnlineRooms";

import XSLessonsAll2 from "@/components/school/admin/XSLessonsAll2";
import XDepartments from "@/components/school/admin/XDepartments";
import Curriculum from "@/components/sekz/Curriculum";
import XTeachers from "@/components/school/admin/XTeachers";
Vue.use(Router);

const withPrefix = (prefix, routes) => 
    routes.map( (route) => {
        route.path = prefix + route.path;
        return route;
    });

const router = new Router({
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    const position = {};

    if (savedPosition) {
      position.x = savedPosition.x;
      position.y = savedPosition.y;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: position.x, y: position.y  })
        }, 1000)
      });
    } 
    else {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0  })
        }, 0)
      });
    }
  },

  
  routes: [
    {
      path: "/xteachers",
      name: "XTeachers",
      component: XTeachers,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/curriculum",
      name: "Curriculum",
      component: Curriculum,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/login",
      name: "Login",
      component: HomeLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/accessbycoderegister",
      name: "XStudentPage",
      component: XStudentPage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/studentlogin",
      name: "StudentLogin",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/teacherlogin",
      name: "TeacherLogin",
      component: TeacherLogin,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/adminman",
      name: "Adminman",
      component: Adminman,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "*",
      redirect: "/dashboard"
    },
    {
      path: "/hello",
      name: "Hello",
      component: Hello,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/mynews",
      name: "MyNews",
      component: MyNews,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "student", "manager"]
      }
    },
    {
      path: "/asuulga",
      name: "Asuulga",
      component: Asuulga,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "student", "manager"]
      }
    },
    {
      path: "/xadetail/:schoolId/:asuulgaId",
      name: "XADetail",
      component: XADetail,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin", "student", "manager"]
      }
    },
    {
			path: '/asuulgaanswering/:asuulgaId/:userId',
			name: 'AsuulgaAnswering',
			props: true, 
			component: () => import("@/components/school/asuulga/AsuulgaAnswering"),
		},
    {
			path: '/asuulgaediting/:schoolId/:asuulgaId',
			name: 'AsuulgaEditing',
			props: true, 
			component: () => import("@/components/school/asuulga/AsuulgaEditing"),
		},
    {
			path: '/asuulgaresults/:schoolId/:asuulgaId',
			name: 'AsuulgaResults',
			props: true, 
			component: () => import('@/components/school/asuulga/AsuulgaResults'),
		},
    {
      path: "/groups",
      name: "Groups",
      component: Groups,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "teacher"]
      }
    },
    {
      name:"XSLessonsAll2",
      path: '/managealllessons',
      component: XSLessonsAll2,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["manager"]
      }
    },
    {
      name:"XOnlineRooms",
      path: '/onlinerooms',
      component: XOnlineRooms,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher",]
      }

    },
    {
      name:"XSongonOnlineRooms",
      path: '/songononlinerooms',
      component: XSongonOnlineRooms,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher",]
      }

    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lessonadd/:semesterId",
      name: "LessonAdd",
      component: LessonAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/lessonedit/:lessonId/:semesterId",
      name: "LessonEdit",
      component: LessonEdit,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonDetail,
      name: "LessonDetail",
      path: "/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonGroup,
      name: "LessonGroup",
      path: "/lesson/group/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonTime,
      name: "LessonTime",
      path: "/lesson/time/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonGroupStudents,
      name: "LessonGroupStudents",
      path: "/lesson/group/students/:lessonId/:groupId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: ContentDetail,
      name: "ContentDetail",
      path: "/lesson/:lessonId/:topicId/:contentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: QuestionDetail,
      name: "QuestionDetail",
      path: "/lesson/:lessonId/:topicId/:contentId/:categoryId/:questionId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonStudent,
      name: "LessonStudent",
      path: "/lesson/:lessonId/students",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      path: "/exam",
      name: "ExamPage",
      component: ExamPage,
      meta: {
        requiresAuth: true
      },
      props: true,
    },
    {
      path: "/examreport",
      name: "ExamReport",
      component: ExamReport,
      meta: {
        requiresAuth: true
      },
      props: true,
    },
    {
      path: "/stat/:schoolId/lesson/:lessonId/topic/:topicId/:contentId",
      name: "ExamResult",
      component: ExamResult,
      props: true,
      meta: {
        requiresAuth: false
      }
    },

    {
      component: LessonAttendance,
      name: "LessonAttendance",
      path: "/lesson/:lessonId/attendance",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["teacher", "sts", "admin"]
      }
    },
    {
      component: LessonGrid,
      name: "LessonGrid",
      path: "/lessons",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    {
      component: LessonGridXDaalgavar,
      name: "LessonGridXDaalgavar",
      path: "/lessongridxdaalgavar",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    
    {
      component: AllLessonStudentScores,
      name: "AllLessonStudentScores",
      path: "/alllessonstudentscores",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["student"]
      }
    },
    {
      component: FinalScores,
      name: "FinalScores",
      path: "/finalscores",
      props: true,
      meta: {
        requiresAuth: false,
      }
    },
    {
      component: LessonDetailForStudent,
      name: "LessonDetailForStudent",
      path: "/public/lesson/:lessonId/:schoolId/:sts",
      props: true,
      meta: {
        requiresAuth: false,
        // authorize: ["student", "teacher"]
      }
    },
    {
      component: ExamResult,
      name: "ExamResult",
      path: "/stat/lesson/:lessonId/topic/:topicId/:contentId",
      props: true,
      meta: {
        requiresAuth: false,
        // authorize: ["student", "teacher"]
      }
    },
    {
      component: ShareLessonToPublicforStudent,
      name: "ShareLessonToPublicforStudent",
      path: "/sharetopublicforstud/lesson/:lessonId/:schoolId/",
      props: true,
      meta: {
        requiresAuth: false,
      }
    },
    {
      component: LessonDetailAdmin,
      name: "LessonDetailAdmin",
      path: "/admin/lesson/:lessonId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    { 
      component: Dashboard,
      name: "Dashboard",
      path: "/dashboard",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: XDashboard,
      name: "XDashboard",
      path: "/studentdashboard",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: MyDashboard,
      name: "MyDashboard",
      path: "/mydashboard",
      meta: {
        requiresAuth: true
      }
    },
    {
      component: MyCalendar,
      name: "MyCalendar",
      path: "/mycalendar",
      meta: {
        requiresAuth: true
      }
    },


    

    {
      component: Dashboard,
      name: "Privacy",
      path: "/privacy",
      meta: {
        requiresAuth: false
      }
    },


    {
      path: "/private/:path/:questionId",
      name: "LessonQuestionAdd",
      component: LessonQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      component: SubSchools,
      name: "SubSchools",
      path: "/subschools",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      component: CreateSchool,
      name: "CreateSchool",
      path: "/createschool",
      meta: {
        requiresAuth: true,
        authorize: ["admin",]
      }
    },
    {
      component: CreateNewSemester,
      name: "CreateNewSemester",
      path: "/createnewsemester",
      meta: {
        requiresAuth: true,
        authorize: ["admin",]
      }
    },
    {
      component: CreateSchoolTeacherAdd,
      name: "CreateSchoolTeacherAdd",
      path: "/createschoolteacheradd/:schoolId",
      
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin",]
      }
    },
    {
      component: TeacherAddFromPublic,
      name: "TeacherAddFromPublic",
      path: "/teacheraddfrompublic/:schoolId/:teacherId",
      
      props: true,
      meta: {
        requiresAuth: false,
        // authorize: ["admin",]
      }
    },

    


    {
      component: CreateSchoolTeacherAddBySector,
      name: "CreateSchoolTeacherAddBySector",
      path: "/createschoolteacheraddbysector/:schoolId/:sectorId",
      
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin",]
      }
    },
    {
      component: ExternalQa,
      name: "ExternalQa",
      path: "/qalinks",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher"]
      }
    },
    {
      component: ExternalQaAdmin,
      name: "ExternalQaAdmin",
      path: "/qaadmin",
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts"]
      }
    },
    {
      path: "/subschools/:schoolId",
      name: "SchoolDetail",
      component: SchoolDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    

    {
      path: "/subschools/:schoolId/department/:departmentId",
      name: "DepartmentDetail",
      component: DepartmentDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },

    {
      path: "/students/:schoolId",
      name: "Students",
      component: Students,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/studentsanalyse/:schoolId",
      name: "StudentsAnalyse",
      component: StudentsAnalyse,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },

    {
      component: StudentDetail,
      name: "StudentDetail",
      path: "/student/:studentId",
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher"]
      }
    },
    {
      path: "/studentadd/:studentId/:schoolId",
      name: "StudentAdd",
      component: StudentAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher"]
      }
    },
    {
      path: "/teachers/:schoolId",
      name: "Teachers",
      component: Teachers,
      props:true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/teacheradd/:teacherId/:schoolId",
      name: "TeacherAdd",
      component: TeacherAdd,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager", "teacher"]
      }
  },
  {
    path: "/adminadd/:adminId/:schoolId",
    name: "AdminManagerAddEdit",
    component: AdminManagerAddEdit,
    props: true,
    meta: {
      requiresAuth: true,
      authorize: ["admin", "sts", "manager", "teacher"]
    }
  },
	{
		path: "/teachersadd",
		name: "TeachersAdd",
		component: TeachersAdd,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
	{
		path: "/studentsadd",
		name: "StudentsAdd",
		component: StudentsAdd,
		meta: {
		  requiresAuth: true,
		  authorize: ["admin", "sts"]
		}
	},
    {
      path: "/lessonqa/:lessonId",
      name: "LessonQA",
      component: LessonQA,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/addinfo",
      name: "AddInfo",
      component: AddInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/alllessons",
      name: "AllLessons",
      component: AllLessons,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/payments",
      name: "Payments",
      component: Payments,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/:detailId",
      name: "DetailQuestions",
      component: DetailQuestions,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/:detailId/score",
      name: "QuestionsScore",
      component: QuestionsScore,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/questionadd/:detailPath/:categoryId/:questionId",
      name: "DetailQuestionAdd",
      component: DetailQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/simplequestionadd/:detailPath/:categoryId/:questionId",
      name: "SimpleQuestionAdd",
      component: SimpleQuestionAdd,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/questionaddbulk/:detailPath/:categoryId",
      name: "QuestionAddBulk",
      component: QuestionAddBulk,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/imageadd/:objectPath",
      name: "ImageAdd",
      props: true,
      component: ImageAdd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/userprofile",
      name: "UserProfile",
      component: UserProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stat/lesson/:lessonId/topic/:topicId/:contentId",
      name: "TestResult",
      component: TestResult,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/lesson/:lessonId/topic/:topicId/create/exam",
      name: "TopicCreateExam",
      component: TopicCreateExam,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/lesson/:lessonId/payment",
      name: "LessonPayment",
      component: LessonPayment,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    
    {
      path: "/cities",
      name: "Cities",
      component: Cities,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/cities/:schoolId",
      name: "CityDetail",
      component: CityDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    {
      path: "/cities/:schoolId/district/:departmentId",
      name: "DistrictDetail",
      component: DistrictDetail,
      props: true,
      meta: {
        requiresAuth: true,
        authorize: ["admin", "sts", "manager"]
      }
    },
    ...withPrefix('/schools',[
      {
        name:"SDepartments",
        path: '/:schoolId/departments',
        component: SDepartments,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        name:"XDepartments",
        path: '/:schoolId/xdepartments',
        component: XDepartments,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        name:"Dungiinhavtgai",
        path: '/:schoolId/dungiinhavtgai',
        component: Dungiinhavtgai,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        name:"SCategories",
        path: '/:schoolId/categories/:departmentId',
        component: SCategories,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        name:"DLessonsByCategory",
        path: '/:schoolId/deparments/:departmentId/categories/:categoryId',
        component: DLessonsByCategory,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        name:"AllLessonTimeTable",
        path: '/:schoolId/AllLessonTimeTable',
        component: AllLessonTimeTable,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin",]
        }

      },
      {
        name:"LessonTimeTable",
        path: '/:schoolId/grid',
        component: DLessonsGrid,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        name:"SchoolCategory",
        path: '/:schoolId/categories',
        component: SchoolCategory,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        path: "/:schoolId/categories/add",
        name: "SchoolCategoryAdd",
        component: SchoolCategoryAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        name:"SchoolSector",
        path: '/:schoolId/sectors',
        component: SchoolSector,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        path: "/:schoolId/sectors/add",
        name: "SchoolSectorAdd",
        component: SchoolSectorAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        name:"SectorDetail",
        path: '/:schoolId/sectors/:sectorId/positions',
        component: SectorDetail,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        name:"Semester",
        path: '/:schoolId/semester',
        component: Semester,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }

      },
      {
        path: "/:schoolId/semester/add",
        name: "SemesterAdd",
        component: SemesterAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      // {
      //   component: ILessonDetail,
      //   name: "ILessonDetail",
      //   path: "/:schoolId/lesson/:lessonId",
      //   props: true,
      //   meta: {
      //     requiresAuth: true,
      //     authorize: ["teacher", "sts", "admin"]
      //   }
      // },
      {
        component: XILessonDetail,
        name: "XILessonDetail",
        path: "/:schoolId/lesson/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
    
      {
        path: "/:schoolId/lessonadd/:semesterId",
        name: "ILessonAdd",
        component: ILessonAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/xaddlesson",
        name: "XAddLesson",
        component: XAddLesson,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/lessonaddgroup",
        name: "ILessonAddGroup",
        component: ILessonAddGroup,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/groupadd",
        name: "GroupAdd",
        component: GroupAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/groupstudent/:lessonId",
        name: "GroupStudent",
        component: GroupStudent,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/lessonedit/:lessonId",
        name: "ILessonEdit",
        component: ILessonEdit,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: IContentDetail,
        name: "IContentDetail",
        path: "/:schoolId/lesson/:lessonId/:topicId/:contentId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: IVideoFrame,
        name: "IVideoFrame",
        path: "/:schoolId/lesson/:lessonId/:topicId/:contentId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: IVideoWatcher,
        name: "IVideoWatcher",
        path: "/:schoolId/lesson/:lessonId/:topicId/:contentId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/lesson/:lessonId/topic/:topicId/:detailId",
        name: "IQuestions",
        component: IQuestions,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/simplequestionadd",
        name: "ISimpleQuestionAdd",
        component: ISimpleQuestionAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/questionadd",
        name: "IQuestionAdd",
        component: IQuestionAdd,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/lesson/:lessonId/topic/:topicId/:detailId/score",
        name: "IQuestionsScore",
        component: IQuestionsScore,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: IQuestionDetail,
        name: "IQuestionDetail",
        path: "/:schoolId/lesson/:lessonId/:topicId/:contentId/:categoryId/:questionId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/questionaddbulk",
        name: "IQuestionAddBulk",
        component: IQuestionAddBulk,
        props: true,
        meta: { 
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonGroup,
        name: "ILessonGroup",
        path: "/:schoolId/lesson/group/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonGroupExam,
        name: "ILessonGroupExam",
        path: "/:schoolId/lesson/:lessonId/topic/:topicId/exam/:contentId/groups/",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonShare,
        name: "ILessonShare",
        path: "/:schoolId/lesson/share/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonGroupStudents,
        name: "ILessonGroupStudents",
        path: "/:schoolId/lesson/group/students",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonTime,
        name: "ILessonTime",
        path: "/:schoolId/lesson/time/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonLog,
        name: "ILessonLog",
        path: "/:schoolId/lesson/log/:lessonId/:programId/:groupId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonSchedule,
        name: "ILessonSchedule",
        path: "/:schoolId/lesson/schedule/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin", "teacher"]
        }
      },
      {
        component: ILessonLogDetail,
        name: "ILessonLogDetail",
        path: "/:schoolId/lesson/logdetail/:lessonId/:logId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/teachersadd",
        name: "ITeachersAdd",
        component: ITeachersAdd,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        path: "/:schoolId/studentsadd",
        name: "IStudentsAdd",
        component: IStudentsAdd,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        path: "/:schoolId/allstudentsadd",
        name: "AddAllStudents",
        component: AddAllStudents,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        component: ILessonStats,
        name: "ILessonStats",
        path: "/:schoolId/lesson/stat/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      { 
        component: ILessonContentScores,
        name: "ILessonContentScores",
        path: "/:schoolId/lesson/:lessonId/content/scores",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonScores,
        name: "ILessonScores",
        path: "/:schoolId/lesson/:lessonId/scores",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ()=> import('@/components/school/lesson/ILessonScoresAyear'),
        name: "ILessonScoresAyear",
        path: "/:schoolId/lesson/:lessonId/finalscores",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonScoresDaalgavar,
        name: "ILessonScoresDaalgavar",
        path: "/:schoolId/lesson/:lessonId/teacherdaalgavar",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        component: ILessonAssignment,
        name: "ILessonAssignment",
        path: "/:schoolId/lesson/:lessonId/assignment",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["teacher", "sts", "admin"]
        }
      },
      {
        path: "/:schoolId/slessons",
        name: "SLessons",
        component: SLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        path: "/:schoolId/slessonsall",
        name: "SLessonsAll",
        component: SLessonsAll,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        path: "/:schoolId/slessonsall2",
        name: "SLessonsAll2",
        component: SLessonsAll2,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts"]
        }
      },
      {
        path: "/:schoolId/listoflessons",
        name: "ListOfLessons",
        component: ListOfLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      {
        path: "/:schoolId/:departmentId/program/:programId/slessons",
        name: "SProgramLessons",
        component: SProgramLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      {
        path: "/:schoolId/:departmentId/program/:programId/xprogramfinalexamscores",
        name: "XProgramFinalexamScores",
        component: XProgramFinalexamScores,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      {
        path: "/:schoolId/:departmentId/program/:programId/myclass",
        name: "MyClassLessons",
        component: MyClassLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      {
        path: "/:schoolId/:departmentId/program/:programId/checkclasslesson",
        name: "CheckClassLessons",
        component: CheckClassLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      {
        path: "/:schoolId/toberemovedlessons",
        name: "TobeRemovedLessons",
        component: TobeRemovedLessons,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin",]
        }
      },
      {
        component: SLessonDetail,
        name: "SLessonDetail",
        path: "/:schoolId/slesson/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        component: ShareLessonToPublic,
        name: "ShareLessonToPublic",
        path: "/:schoolId/sharelessontopublic/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        component: SLessonGroup,
        name: "SLessonGroup",
        path: "/:schoolId/slesson/group/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        component: SLessonGroupStudents,
        name: "SLessonGroupStudents",
        path: "/:schoolId/slesson/group/students",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        component: SLessonTime,
        name: "SLessonTime",
        path: "/:schoolId/slesson/time/:lessonId",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        component: STeachersLate,
        name: "STeachersLate",
        path: "/:schoolId/teachers/lessoninfo",
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["sts", "admin"]
        }
      },
      {
        path: "/:schoolId/newscategory",
        name: "NewsCategory",
        component: NewsCategory,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        path: "/:schoolId/news/:parentPath/:typePath",
        name: "News",
        component: News,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        path: "/:schoolId/xnews",
        name: "XNews",
        component: XNews,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager", "teacher"]
        }
      },
      {
        path: "/:schoolId/xnewsdetail/:newsId/:userId",
        name: "XNewsDetail",
        component: XNewsDetail,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager", "teacher", "student"]
        }
      },
      
      {
        path: "/:schoolId/teacher/:teacherPath",
        name: "TeacherLessons",
        component: TeacherLessons,
        props: true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "manager"]
        }
      },
      {
        path: "/:schoolId/:departmentId/:programId/groupstudents",
        name: "IGroupStudents",
        component: IGroupStudents,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
      
      {
        component: StudentContentDetail,
        name: "StudentContentDetail",
        path: "/lesson/:lessonId/:topicId/:contentId",
        props: true,
        meta: {
          requiresAuth: false,
        }
      },
      {
        component: StudentLog,
        name: "StudentLog",
        path: "/public/lesson/:lessonId/log",
        props: true,
        meta: {
          requiresAuth: true,
        }
      },
      {
        component: StudentScores,
        name: "StudentScores",
        path: "/public/lesson/:lessonId/score",
        props: true,
        meta: {
          requiresAuth: true,
        }
      },
      {
        component: StudentAssignment,
        name: "StudentAssignment",
        path: "/public/lesson/:lessonId/assignment",
        props: true,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "/:schoolId/:departmentId/:programId/studentadd",
        name: "ProgramStudentAdd",
        component: ProgramStudentAdd,
        props:true,
        meta: {
          requiresAuth: true,
          authorize: ["admin", "sts", "teacher"]
        }
      },
    ]),
  ],
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const authorize = to.meta.authorize;
  const currentUser = firebase.auth().currentUser;
  if (store.getters.enabled == true) {
    if (authorize != undefined) {
      if (requiresAuth && !currentUser) {
        next("/login");
      }
      else if (requiresAuth && currentUser) {
        if (
          authorize != null &&
          authorize.length > 0 &&
          store.getters.userProfile != null &&
          store.getters.userProfile.role != null &&
          authorize.includes(store.getters.userProfile.role)
        ) {
          next();
        } 
        else {
          next("/");
        }
      } 
      else if (requiresAuth == false) {
        next();
      } 
      else next("/login");
    } 
    else {
      if (requiresAuth && !currentUser) {
        next("/login");
      } 
      else if (requiresAuth && currentUser) {
        next();
      } 
      else if (requiresAuth == false) {
        next();
      } 
      else next("/login");
    }
  } 
  else {
    if (requiresAuth && !currentUser) {
      next("/login");
    } 
    else if (requiresAuth && currentUser) {
      if (to.name != "AddInfo") {
        next("/addinfo");
      } 
      else 
        next();
    } 
    else if (requiresAuth == false) {
      next();
    } 
    else {
      next("/login");
    }
  }
});

export default router;
